import store_param from "@/store/mods/parametres/config"
import $ from 'jquery'
import ManageAntecedent from '@/views/parametres/configs/param-antecedents/manage-antecedent'


export default {
    name: 'param-antecedents',
    components: {
        ManageAntecedent
    },
    props: [],
    data() {
        return {
            section_antecedents: [],
            atcd_loading: true,
            atcd_empty: false,
            is_error: false,

            fields: [
				{ key: 'antecedent', label: 'Antécédent' },  { key: 'statut', label: 'Statut' },  
                { key: 'actions', label: 'Action.s' }
			],
			filter: "",
			perPage: 40,
			currentPage: 1,
            toggler: 0,
            selected_atcd: {
                atcd_id: 0,
                atcd_label: "",
                atcd_slug: "",
                type_consultations: []
            }
        }
    },

    computed: {

    },

    mounted() {
        this.getSectionAntecedents()
    },

    methods: {
        getSectionAntecedents() {
            this.atcd_loading = true
            store_param.getListeSectionAntecedents().then((response) => {
                this.section_antecedents = response
                if (response.length > 0) {
                    this.atcd_empty = false
                } else {
                    this.atcd_empty = true
                }
                this.atcd_loading = false
            }).catch(() => {
                this.atcd_loading = false
                this.is_error = true
            })
        },

        addAntecedent() {
            this.toggler = (this.toggler == 0)?1:0
            $('.ges-atcd').modal('show')

            this.selected_atcd = {
                atcd_id: 0,
                atcd_label: "",
                atcd_slug: "",
                type_consultations: []
            }
        },

        editSectionATCD(atcd) {
            this.toggler = (this.toggler == 0)?1:0
            this.selected_atcd = atcd

            $('.ges-atcd').modal('show')
        }, 

        setATCDtoDeactivate(atcd) {
            this.selected_atcd = atcd
            this.toggler = (this.toggler == 0)?1:0

            $('.deactivate-atcd').modal('show')
        }
            
    }
}